import React from "react";

const taxiData = [
  {
    image: "/images/fleets/Ertiga.jpg",
    title: "Maruti Ertiga",
    passengers: 6,
    rate: "₹15/KM",
  },
  {
    image: "/images/fleets/crysta.jpg",
    title: "Innova Crysta",
    passengers: 7,
    rate: "₹21/KM",
  },
  {
    image: "/images/fleets/kia.jpg",
    title: "Kia Carens",
    passengers: 6,
    rate: "₹18/KM",
  },
];

const TaxiStyleOne = () => {
  return (
    <section className="taxi-style-one py-5">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <p className="text-warning fw-bold mb-2">
            Our Premium Fleet
          </p>

          <h2 className="fw-bold">
            Choose Your Vehicle
          </h2>
        </div>

        {/* Cards */}
        <div className="row">
          {taxiData.map((taxi, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div
                className="card border-0 shadow-lg h-100"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                }}
              >
                {/* Image */}
                <div
                  style={{
                    background: "#f9b800",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={taxi.image}
                    alt={taxi.title}
                    className="img-fluid"
                    style={{
                      height: "160px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Content */}
                <div className="card-body text-center">
                  <h4 className="fw-bold mb-3">
                    {taxi.title}
                  </h4>

                  <ul className="list-unstyled mb-4">
                    <li className="mb-2">
                      <strong>Rate:</strong> {taxi.rate}
                    </li>

                    <li>
                      <strong>Passengers:</strong>{" "}
                      {taxi.passengers}
                    </li>
                  </ul>

                  <button
                    className="btn btn-warning px-4"
                    onClick={() =>
                      (window.location.href = "/booking")
                    }
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaxiStyleOne;